const PlayCounter = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 5.99899C9.99967 6.12213 9.96952 6.24277 9.9129 6.34752C9.85627 6.45227 9.77537 6.53706 9.67917 6.59247L3.84583 9.92664C3.76456 9.97425 3.67465 9.99937 3.58333 10C3.47412 10.0004 3.367 9.96574 3.27417 9.89997C3.1901 9.83991 3.12081 9.75635 3.07284 9.65717C3.02487 9.558 2.9998 9.44649 3 9.33316V2.66482C3.0003 2.55115 3.02602 2.43945 3.0747 2.34033C3.12339 2.24122 3.19344 2.15798 3.27818 2.09852C3.36293 2.03905 3.45957 2.00534 3.55892 2.00058C3.65827 1.99583 3.75703 2.02018 3.84583 2.07133L9.67917 5.40551C9.77537 5.46092 9.85627 5.5457 9.9129 5.65046C9.96952 5.75521 9.99967 5.87585 10 5.99899Z"
        fill="#707070"
      />
    </svg>
  );
};

export default PlayCounter;
